const clearObjNulls = (obj) => {
    Object.keys(obj).forEach((key) => {
        let value = obj[key];
        if (value === null) {
            delete obj[key];
        }
    });
    return obj;
};

export default clearObjNulls;
